const admins = [
    {
        
        
        id:1,
        admin_name:"test",
        email:'test@gmail.com',
        admin_phone:1234567890,
    }, {
        
        
        id:2,
        admin_name:"partner2",
        email:'test@gmail.com',
        admin_phone:1234567890,
    },
]


export default admins;